import createTeachers from "./createTeachers";
import createClasses from "./createClasses";
import createUserAssessments from "./createUserAssessments";
import { db } from "../../../config/firebaseconfig";
import createStudents from "./createStudents";

/**
 * Restores a csv upload backup that was previously unwound.
 * @param {object} backup the backup object from db legacyUploadBackups
 * @param {object} school school the backup belongs to
 * @param {function} updateState this.setState bound to UploadCSVBackupsContainer
 */
export default function restoreBackup (backup, school, updateState) {
  
  // utility function that returns ids
  function getIds (array) {
    return array.map(obj => obj.id || obj.userAssessmentId)
  }

  const {
    assessmentId,
    id,
    schoolYear,
    uploadedData,
  } = backup
  let newBackup = backup

  updateState({
    restoreStatus: 'Restoring teachers...',
    backupRestoring: id,
  })
  return createTeachers(uploadedData, school, schoolYear)
    .then(createdTeachers => {
      // create new teachers
      updateState({restoreStatus: 'Restoring classes...'})
      newBackup.createdTeachers = getIds(createdTeachers)
      return createClasses(uploadedData, school, schoolYear)
    })
    .then(createdClasses => {
      // create new classes
      updateState({restoreStatus: 'Restoring students...'})
      newBackup.createdClasses = getIds(createdClasses)
      return createStudents(uploadedData, school, schoolYear)
    })
    .then(createdStudents => {
      // create new students
      updateState({restoreStatus: 'Processing student responses...'})
      newBackup.createdStudents = getIds(createdStudents)
      return createUserAssessments(
        uploadedData,
        school,
        schoolYear,
        assessmentId,
        updateState,
      )
    })
    .then(createdUserAssessments => {
      // create new userAssessments
      updateState({
        restoreStatus: `Restore complete! Refresh your browser 
                        to take more actions on this page.`,
      })
      newBackup.createdUserAssessments = getIds(createdUserAssessments)
      newBackup.active = true
      // replace backup in db    
      return db.collection('legacyUploadBackups').doc(id)
        .set(newBackup)
    })
    .catch(err => {
      console.log(err)
      updateState({restoreError: true})
    })

} 


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/restoreBackup.js